import {BaseMutationOptions, BaseUseMutationResult, useBaseMutation} from "@bounce/shared/requests";
import {AxiosResponse} from "axios";
import {axiosConsumerAppInstance} from "~/api/ConsumerApiManager";

type Variables = {
  accountId: string;
  balance?: number;
};
type Data = boolean;

const resetAccount = async (variables: Variables): Promise<Data> => {
  await axiosConsumerAppInstance.post<boolean, AxiosResponse<boolean>>(
    `/dev/reset-account/${variables.accountId}`,
    undefined,
    variables.balance != null ? {params: {balance: variables.balance}} : undefined
  );
  return true;
};

export const useResetAccount = (
  options?: BaseMutationOptions<Data, Variables>
): BaseUseMutationResult<Data, Variables> => {
  return useBaseMutation(resetAccount, {
    ...options,
    prefixKeysToReset: (data, variables) => [["user"], ["account", variables.accountId]],
  });
};
